import React, { useContext } from 'react';
import { Button, KIND } from 'baseui/button';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import { DrawerContext, EMPTY_NUMBER, EMPTY_STRING, Label } from 'commons-ui';
import _startsWith from 'lodash/startsWith';
import _get from 'lodash/get';
import { StyledLink } from 'baseui/link';
import dayjs from 'dayjs';
import { IPermissionSet } from 'models/settingsV2.model';
import PermissionsSetDetails from '../../permissionsSetDetails';

export const COL_NAMES = {
	permissionSetName: 'name',
	permissionSetDesc: 'description',
	createdAt: 'createdAt',
	createdBy: 'createdBy'
};
export const columnConfigs = [
	CustomColumn({
		title: 'Permission Set Name',
		maxWidth: 300,
		mapDataToValue: (data: IPermissionSet) => {
			return {
				permissionSetName: String(_get(data, COL_NAMES.permissionSetName, EMPTY_STRING)),
				permissionIds: data.permissionIds || []
			};
		},
		renderCell: (params: any) => {
			const { value } = params;

			const { setDrawerConfig } = useContext(DrawerContext);
			const handleOnClick = (event: any) => {
				event.preventDefault();
				event.stopPropagation();
				setDrawerConfig({ isOpen: true, content: <PermissionsSetDetails permissionsSetData={value} /> });
			};

			return (
				<Button
					kind={KIND.tertiary}
					onClick={handleOnClick}
					overrides={{
						Root: {
							style: ({ $theme }) => ({
								color: $theme.colors.primaryA,
								height: '100%',
								width: '100%',
								fontSize: '12px',
								fontWeight: 'normal'
							})
						}
					}}>
					<StyledLink>{value.permissionSetName}</StyledLink>
				</Button>
			);
		},
		textQueryFilter: (textQuery: String, data: any): boolean => {
			return _startsWith(data.permissionSetName, `${textQuery}`);
		}
	}),
	CustomColumn({
		title: 'Permission Set Description',
		maxWidth: 300,
		mapDataToValue: (data: IPermissionSet) => {
			return {
				desc: String(_get(data, COL_NAMES.permissionSetDesc, EMPTY_STRING))
			};
		},
		renderCell: (params: any) => {
			const { value } = params;
			const truncatedDesc = value.desc.split(' ').slice(0, 5).join(' ') + (value.desc.split(' ').length > 5 ? '...' : '');
			return (
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-start',
						alignItems: 'center',
						width: '100%',
						height: '100%',
						textAlign: 'left'
					}}>
					<Label label={truncatedDesc} toolTip={value.desc} />
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Created At',
		mapDataToValue: (data: IPermissionSet) => {
			return dayjs(new Date(_get(data, COL_NAMES.createdAt, EMPTY_NUMBER))).format('DD-MM-YYYY hh:mm A') || EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Created By',
		mapDataToValue: (data: IPermissionSet) => {
			return String(_get(data, COL_NAMES.createdBy, EMPTY_STRING));
		}
	})
];

export default { columnConfigs, COL_NAMES };
